import React from "react";
import { Link } from "react-router-dom";
import gif from "../../../assets/gif.gif";

const CallToAction = () => {
  const scrollHeader = () => {
    window.scrollTo({ top: 0, behavior: "instant" });
  };
  return (
    <div className="health-care-bottom-page-wrapper">
      <div className="row">
        <div className="col-12 col-md-9">
          <h4 className="title_text">
            Optimize Your Healthcare Operations with Soori Corporation
          </h4>
          <p className="contact_investers_para">
            We’re not just a provider, we’re the partner you can rely on to turn
            vision into reality—combining cutting-edge technology with industry
            insights to craft solutions that propel your business forward.
          </p>
          <Link
            to="/connect-with-us"
            className="btn-md btn-dark border-0"
            onClick={() => scrollHeader()}
          >
            Request a Demo Today!
          </Link>
        </div>
        <div className="col-12 col-md-3">
          <div className="circle-gif">
            <img src={gif} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallToAction;
